import { useState } from "react";
import { useAuth } from "../contexto/AuthContexto";
import { EyeIcon, EyeOffIcon } from "../componentes/Iconos";

const LoginPage = () => {
  const { login } = useAuth();
  const [error, setError] = useState("");
  const [entrando, setEntrando] = useState(false);
  const [verClave, setVerClave] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setEntrando(true);
    try {
      await login(e.target.username.value, e.target.password.value);
    } catch (err) {
      setError(err.message);
    } finally {
      setEntrando(false);
    }
  };

  return (
    <div className="login-pantalla">
      <div className="login-tarjeta">
        <div className="login-barra" />

        <div className="login-contenido">
          <header className="login-encabezado">
            <h1>Rústiko</h1>
            <p>Control de ventas y abonos</p>
          </header>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label className="form-label" htmlFor="username">
                Usuario
              </label>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="username"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="password">
                Contraseña
              </label>
              <div className="campo-clave">
                <input
                  id="password"
                  name="password"
                  type={verClave ? "text" : "password"}
                  autoComplete="current-password"
                  required
                />
                {/* En el celular es fácil equivocarse escribiendo a ciegas,
                    y tras varios intentos fallidos el sistema bloquea. */}
                <button
                  type="button"
                  className="ver-clave"
                  onClick={() => setVerClave((v) => !v)}
                  title={verClave ? "Ocultar la contraseña" : "Mostrar la contraseña"}
                  aria-label={verClave ? "Ocultar la contraseña" : "Mostrar la contraseña"}
                >
                  {verClave ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="btn-entrar" disabled={entrando}>
              {entrando ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
